import ServiceRequestWidget from './Widget';
export type { WidgetProps } from './Widget.types';

export default ServiceRequestWidget;
